import { configs } from '../../../../constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';

const {
    routes,
    endpoints,
    externalEndpoints,
    states : {
        CALIFORNIA,
        PENNSYLVANIA,
        NEVADA,
        NEW_JERSEY,
        NEW_MEXICO,
        MINNESOTA,
        IDAHO,
        GEORGIA,
        VIRGINIA,
        GETINSURED
    }
} = configs;


export const assiterNavLinksNames = {
    PENDING_EMP:  'nav_pending_emp',
    ASSISTER_SELF_DELEGATION_TOOL: 'nav_self_delegation_tool_assister',
    PENDING_DELEGATION_REQ: 'nav_pending_delegation_req',
    MY_PROFILE: 'nav_my_profile',
    ADD_NEW_EMP: 'nav_add_new_emp',
    ADD_NEW_IND: 'nav_add_new_indiv',
    START_NEW_APP: 'nav_start_new_app',
    ENROLLER_TOOLKIT: 'nav_enrmnt_counselor',
    MY_DELEGATION: 'delegation_header--2',
    TICKET: 'nav_my_tickets'
};

export const assisterNavLinks = {
    [CALIFORNIA]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.ASSISTER_SELF_DELEGATION_TOOL,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.CA_LINKS.ASSISTER_SELF_DELEGATION_TOOL,
                    visibility: userActiveRoleName => 'ASSISTER' == userActiveRoleName,
                    text: assiterNavLinksNames.ASSISTER_SELF_DELEGATION_TOOL
                },
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ
                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.START_NEW_APP,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.CA_LINKS.CA_START_NEW_APP,
                    visibility: true,
                    text: assiterNavLinksNames.START_NEW_APP,
                },
                {
                    name: assiterNavLinksNames.ENROLLER_TOOLKIT,
                    icon: 'wrench',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.CA_LINKS.CA_TOOLKIT,
                    visibility: true,
                    text: assiterNavLinksNames.ENROLLER_TOOLKIT,
                    blank: true
                }
            ]
        }

    ],
    [PENNSYLVANIA]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [NEW_MEXICO]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [NEVADA]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [NEW_JERSEY]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text:assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [GEORGIA]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [MINNESOTA]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [IDAHO]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text:assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [GETINSURED]: [
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ]
};
